import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs/internal/Observable';
import { GetInvoicesPaginatedResponse, InvoiceDetailResponse } from '../domain/invoices.model';
import { InvoicesRepository } from './invoices.repository';

@Injectable()
export class InvoicesApiService implements InvoicesRepository {
    private _http = inject(HttpClient);

    listInvoices(
        page: number,
        pageSize: number,
        status: string | null,
        type: string | null,
        includeInvoiceWithoutPayment: boolean
    ): Observable<GetInvoicesPaginatedResponse> {
        const params = new HttpParams().set('page', page).set('size', pageSize);
        if (status) {
            params.set('status', status);
        }
        if (type) {
            params.set('type', type);
        }
        if (includeInvoiceWithoutPayment) {
            params.set('includeInvoiceWithoutPayment', includeInvoiceWithoutPayment);
        }
        const options = {
            params,
        };
        return this._http.get<GetInvoicesPaginatedResponse>(`${environment.url}${MICROSERVICES.invoices}/invoices`, options);
    }

    getInvoiceDetail(id: string): Observable<InvoiceDetailResponse> {
        return this._http.get<InvoiceDetailResponse>(`${environment.url}${MICROSERVICES.invoices}/invoices/${id}`);
    }

    downloadInvoicePdf(id: string): Observable<Blob> {
        const headers = new HttpHeaders({
            Accept: 'application/pdf',
        });

        return this._http.get(`${environment.url}${MICROSERVICES.invoices}/invoices/${id}/activities`, {
            headers: headers,
            responseType: 'blob',
        });
    }
}
